import { useEffect, createRef, useRef } from "react";
import React, { useState } from "react";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import { EditorState, convertFromRaw, convertToRaw, ContentState, Modifier, Entity, CompositeDecorator, AtomicBlockUtils, convertFromHTML, RichUtils, SelectionState } from "draft-js";
import { FilePond } from "react-filepond";
import "filepond/dist/filepond.min.css";
import { API_BASE } from "../../utils/Constants";
import { getToken } from "../../utils/Auth";
import draftToHtml from "draftjs-to-html";
import { defaultSuggestionsFilter } from "draft-js-mention-plugin";
import 'draft-js/dist/Draft.css';
import 'draft-js-mention-plugin/lib/plugin.css';
import { ShowMoreHide } from "./ShowMoreHide";
import FeedAttachments from "../courses/DetailCoursesBlocks/FeedAttachments";
import htmlToDraft from 'html-to-draftjs';
import { useCallback } from "react";
import EditorComponent from "./EditorComponent";
import { validateFileSize } from "../../utils/commonFunction";


function HtmlInputEditorShowComment({ data, tagClass, setCurrentVideo, editableArr, allData, attachmentClick, sendClick, placeholder, isImportant, setIsImportant, importantArr, userData, deletedFileHandle, setShowHideEdit , deleteFileData= [],setDeletedFileData=null }) {
    const isInvalid = false;
    const [videoArr, setVideoArr] = useState([]);
    const [showMore, setShowMore] = useState(false);
    const [editable, setEditable] = useState(false);
    const [showLess, setShowLess] = useState(null);
    const [inputError, setInputError] = useState('');
    const [sendActive, setSendActive] = useState(false);
    const [files, setFiles] = useState([]);
    const [showFilePond, setShowFilePond] = useState(false);
    const [removeFile, setRemoveFile] = useState(null);
    const [attachments, setAttachments] = useState([]);
    const [sizes, setSizes] = useState([]);
    const [suggestions, setSuggestions] = useState(userData);

    const btnAttachment = createRef();
    const filePondRef = createRef();
    const editorReference = useRef();
    const HandleSpan = useCallback((props) => {
        return (
            <span className="check">
                <span
                    style={styles.handle}
                    data-offset-key={props.offsetKey}
                    className="checkkkk"
                >
                    {props.children}
                </span>
            </span>
        );
    },[]);

    function handleStrategy(contentBlock, callback, contentState) {
        findWithRegex(HANDLE_REGEX, contentBlock, callback);
    }

    const compositeDecorator = new CompositeDecorator([{ strategy: handleStrategy, component: HandleSpan }]);
    const [editorState, setEditorState] = React.useState(() => EditorState.createEmpty(compositeDecorator));

    useEffect(() => {
        const messageValue = convertToRaw(editorState.getCurrentContent());
        feedStateChange(messageValue);
    }, [deleteFileData,attachments]);

    useEffect(() => {
        let isBlock = isJsonString(data)
        if (isBlock) {
            let entitymap = JSON.parse(data).entityMap
            let embedArr = []
            let otherEntityArr = []
            let finalData = JSON.parse(data)
            if(entitymap){
                Object.values(entitymap).map((entity, index) => {
                    if (entity.type === 'EMBEDDED_LINK') {
                        let url = (entity.data.src).substring(2, (entity.data.src).length)
                        let thumbId = ''
                        let thumbImg = ''
                        if ((url.substring(0, 7) == 'youtube') || (url.substring(0, 7) == 'www.you')) {
                            thumbId = youtube_parser(url)
                            thumbImg = `https://img.youtube.com/vi/${thumbId}/sddefault.jpg`
                        }
                        else if ((url.substring(0, 7) == 'player.') || (url.substring(0, 7) == 'www.pla')) {
                            thumbId = vimeo_parser(url)
                            thumbImg = `https://vumbnail.com/${thumbId}.jpg`
                        }
                        embedArr.push({ src: (entity.data.src).substring(2, (entity.data.src).length), thumbnail: thumbImg });
                        finalData.entityMap[index] = {}
                    }
                    else {
                        // otherEntityArr.push(entity)
                    }
                });
            }

            let blocks = JSON.parse(data).blocks
            let tempTxt = ''
            if(blocks){
                blocks.map(i => {
                    tempTxt = tempTxt + '' + (i.text)
                })
                if ((blocks && (blocks.length > 3)) || (tempTxt.length > 200) || (blocks.length > 0 && tempTxt.includes("\n\n"))) {
                    setShowMore(true)
                }
            }

            if (embedArr.length > 0) {
                setVideoArr(embedArr)
            }
            try{
                const blocksFromHTML = convertFromRaw(finalData);
    
                setEditorState(EditorState.createWithContent(blocksFromHTML));
            }catch(err){
                console.log(err)
            }
        }
        else {
            if(data){
                const blocksFromHtml = htmlToDraft(data);
                const { contentBlocks, entityMap } = blocksFromHtml;
                const contentState = ContentState.createFromBlockArray(contentBlocks, entityMap);
                setEditorState(EditorState.createWithContent(contentState));
            }
        }
    }, []);

    useEffect(() => {
        let isBlock = isJsonString(data)
        if (isBlock) {
            const messageValue = convertToRaw(editorState.getCurrentContent());


            let blocks = messageValue.blocks
            let tempTxt = ''
            blocks.map(i => {
                tempTxt = tempTxt + '' + (i.text).trim()
            })
            if (videoArr.length != 0) {
                if (tempTxt == '') {
                    let contentState = editorState.getCurrentContent();
                    const block = contentState.getBlockMap().first();
                    const next = contentState.getBlockAfter(block.getKey());

                    if (block && next) {
                        const removeSelection = new SelectionState({
                            anchorKey: block.getKey(),
                            anchorOffset: block.getText().length,
                            focusKey: next.getKey(),
                            focusOffset: 0
                        });

                        let newContentState = Modifier.removeRange(
                            contentState,
                            removeSelection,
                            "forward"
                        );

                        let newEditorState = EditorState.push(
                            editorState,
                            newContentState,
                            "remove-range"
                        );
                        setEditorState(newEditorState);
                    }
                }
            }
        }
    }, [editorState])

    useEffect(() => {
        if (editableArr.includes(allData.id)) {
            setShowMore(false)
            setShowLess(false)
            setEditable(true)
        }
        else {
            setEditable(false)
        }
    }, [editableArr])

    const youtube_parser = (url) => {
        var regExp = /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#&?]*).*/;
        var match = url.match(regExp);
        return (match && match[7].length == 11) ? match[7] : false;
    }

    const vimeo_parser = (url) => {
        let regEx = /(https?:\/\/)?(www\.)?(player\.)?vimeo\.com\/?(showcase\/)*([0-9))([a-z]*\/)*([0-9]{6,11})[?]?.*/;
        let match = url.match(regEx);
        if (match && match.length == 7) {
            let videoId = match[6];
            return videoId
        }
    }

    function isJsonString(str) {
        try {
            JSON.parse(str);
        } catch (e) {
            return false;
        }
        return true;
    }

    const HANDLE_REGEX = /\@[\w]+/g;
    const styles = {
        editor: { border: "1px solid #ddd", cursor: "text", fontSize: 16, minHeight: "40px", padding: 10, background: "#000" },
        handle: { color: "rgba(98, 177, 254, 1.0)", direction: "ltr", unicodeBidi: "bidi-override" },
    };

    function findWithRegex(regex, contentBlock, callback) {
        const text = contentBlock.getText();
        let matchArr, start;
        while ((matchArr = regex.exec(text)) !== null) {
            start = matchArr.index;
            callback(start, start + matchArr[0].length);
        }
    }

    const onEditorStateChange = (editorState) => setEditorState(editorState);

    const getBase64 = async (file) => {
        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = () => resolve(reader.result);
            reader.onerror = (error) => reject(error);
        });
    };

    const handlePastedFiles = async (files) => {
        getBase64(files[0])
            .then((data) => {
                setEditorState(insertImage(data));
            })
            .catch((error) => {
                console.log(error);
            });
    };

    const insertImage = (url) => {
        const contentState = editorState.getCurrentContent();
        const contentStateWithEntity = contentState.createEntity("IMAGE", "IMMUTABLE", { src: url });
        const entityKey = contentStateWithEntity.getLastCreatedEntityKey();
        const newEditorState = EditorState.set(editorState, { currentContent: contentStateWithEntity });
        return AtomicBlockUtils.insertAtomicBlock(newEditorState, entityKey, " ");
    };

    const renderVideos = useCallback(() => {
        if (videoArr.length > 0) {
            return videoArr.map(i => {
                return (
                    <div onClick={() => setCurrentVideo(i.src)} className="modal-thumb" data-toggle="modal" data-target="#staticBackdrop">
                        <div className="modal-thumb-play">
                            <span><i class="fas fa-play"></i></span>
                        </div>
                        <img width='100%' src={i.thumbnail} />
                    </div>
                )
            })
        }
        else {
            return null
        }
    },[])

    const feedStateChange = (e) => {
        let blocks = e.blocks;
        let tempTxt = '';

        blocks.forEach((i, idx) => {
            const text = (i.text || '').trim();
            tempTxt += text;
        });

        let entitymap = e.entityMap;
        let embedArr = [];

        Object.values(entitymap).forEach((entity, idx) => {
            if (entity.type === 'EMBEDDED_LINK') {
                embedArr.push(entity.data.src);
            }
        });

        const hasText = tempTxt.trim() !== '';
        const hasEmbed = embedArr.length > 0;
        const hasAttachment = attachments?.length > 0;
        const hasDeleted = deleteFileData.length > 0;
        const remainingAttachments = allData.attachments.length - deleteFileData.length;
        const hasRemainingAttachments = remainingAttachments > 0;

        const condition1 = !hasDeleted && hasRemainingAttachments;
        const condition2 = hasDeleted && hasRemainingAttachments;
        const finalCondition =
            hasText ||
            hasEmbed ||
            hasAttachment ||
            condition1 ||
            condition2;
        setSendActive(finalCondition);
    };

    const handleSendClick = () => {
        const forFormik = draftToHtml(
            convertToRaw(editorState.getCurrentContent())
        );
        const messageValue = forFormik
        sendClick(messageValue, allData.id, attachments, sizes, allData.message_id)
        setAttachments([])
        setSizes([])
        setFiles([]);
        setShowFilePond(false);
    }

    const handleFiles = (event) => {
        const ufiles = event.target.files;
        if (ufiles.length > 0) {
            for (var i = 0; i < ufiles.length; i++) {
                if (ufiles[i]) {

                    if (!validateFileSize(ufiles[i])) continue;

                    if (filePondRef.current) {
                        filePondRef.current
                            .addFile(ufiles[i])
                            .then((file) => {})
                            .catch((error) => console.log(error));
                    }
                }
            }
        }
    };

    const handleAttachment = () => {
        // reseting input so same file can be selected again
        if (btnAttachment.current) {
            btnAttachment.current.value = null;
        }
        btnAttachment.current.click();
    };

    const attachmentsArrUpdate = (file) => {
        let tempAttach = attachments
        for (var i = 0; i < tempAttach.length; i++) {
            if (tempAttach[i].includes(file.split('.')[0])) {
                tempAttach.splice(i, 1);
                break;
            }
        }
        if (tempAttach.length < 1) {
            setTimeout(() => {
                setShowFilePond(false)
                // setShowCurser(!showcursure)
            }, 500);
        }
    }

    const handleUploadedFiles = (response) => {
        let newObj = {}
        let blocks = isJsonString(response)
        if (blocks) {
            newObj = JSON.parse(response)
            setAttachments((attachments) => [...attachments, newObj.fullDocFilePath]);
            setSizes((pre) => [...pre, newObj.size]);
            setSendActive(true);
        }
    };

    const handleDragEnter = event => {
        setShowFilePond(true);
    };

    const expand = () => {
        if (showMore) {
            setShowMore(false);
            setShowLess(true)
        }
    }

    const imgAndText = (data) => {
        // console.log("data", data);
        // console.log("convertToRaw(data.getCurrentContent())",convertToRaw(data.getCurrentContent()) );
        // let tempState = EditorState.createWithContent(convertFromRaw(JSON.parse(data)));
        const forFormik = draftToHtml(convertToRaw(data.getCurrentContent()));
        // console.log("forFormik", forFormik);
        //         const blockRenderMap = DefaultDraftBlockRenderMap.set('p', { element: 'p' });
        //         const blocksFromHTML = convertFromHTML(forFormik, getSafeBodyFromHTML, blockRenderMap)
        //         .map(block => (block.get('type') === 'p' ? block.set('type', 'unstyled') : block));
        //         const contentState = ContentState.createFromBlockArray(blocksFromHTML);
        // console.log("contentState", contentState);
        return forFormik
    }

    const onSearchChange = ({ value }) => {
        setSuggestions(defaultSuggestionsFilter(value, suggestions))
    };

    const StyleButton = (props) => {
        let onClickButton = (e) => {
            e.preventDefault();
            props.onToggle(props.style);
        };
        return <button className="fontStyle draft-editor-btn" onMouseDown={onClickButton}>{props.label}</button>;
    };

    const InlineStyleControls = (props) => {
        return (
            <div>
                {INLINE_STYLES.map((type) => (
                    <StyleButton
                        key={type.label}
                        label={type.label}
                        onToggle={props.onToggle}
                        style={type.style}
                    />
                ))}
            </div>
        );
    };

    const onInlineClick = (e) => {
        let nextState = RichUtils.toggleInlineStyle(editorState, e);
        setEditorState(nextState);
    };

    const INLINE_STYLES = [
        { label: <i>I</i>, style: "ITALIC" },
        { label: <b>B</b>, style: "BOLD" },
        { label: <u>U</u>, style: "UNDERLINE" },
    ];

    const editorRef = useRef(null);
    const handleClickOutside = (event) => {
        const target = event.target;

        const isInsideEditor = editorRef.current?.contains(target);

        // group all "ignore" selectors here
        const isIgnored =
            target.closest('.swal2-container') ||
            target.closest('.filepond--root') ||
            target.closest('.attachment-container') ||
            target.closest('.attach-comments') ||
            target.closest('.hold-show') ||
            target.closest('.post-input-content') ||

            // newly added ones
            target.closest('.rdw-embedded-modal-btn') ||
            target.closest('.rdw-editor-toolbar') ||
            target.closest('.rdw-editor-main') ||
            target.closest('.rdw-suggestion-option') ||
            target.closest('.edit_main_thread') ||
            target.closest('.public-DraftStyleDefault-block') ||
            target.closest('.rdw-embedded-modal-link-input');

        const shouldClose =
            editorRef.current &&
            !isInsideEditor &&
            !isIgnored;

        if (shouldClose) {
            setEditable(false);
            setShowHideEdit([]);
        }
    };

    useEffect(() => {
        document.addEventListener('click', handleClickOutside);
        return () => {
            document.removeEventListener('click', handleClickOutside);
        };
    }, []);

    useEffect(() => {
        setEditable(false)
    }, [data])

    return (
        <div
            className={`new-discussion-box ${!isInvalid ? (`post-input-content ${editable ? '' : 'readonly'} mb-0 ` + tagClass) : "file-req is-invalid mb-4"}`}
            onClick={expand}
            ref={editorRef}
        >
            <div className={`${showMore ? "" : ''} rdw-editor-position`} onDragEnter={editable ? handleDragEnter : null}>
                <div className={!editable ? "d-none" : ""}>
                <EditorComponent 
                    editable={editable}
                    editorState={editorState}
                    onEditorStateChange={onEditorStateChange}
                    handlePastedFiles={handlePastedFiles}
                    feedStateChange={feedStateChange}   
                    suggestions={suggestions}
                />
                </div>
                {editable ? <>
                    <div className="action-input-content edit-buttons-new">
                        <button onClick={() => { setIsImportant(allData, !isImportant) }} className={`btn btn-input-action hold-show ${isImportant ? 'active' : ''}`} title="Important"><i className="fal fa-exclamation hold-show"></i></button>
                        <button onClick={handleAttachment} className="btn btn-input-action hold-show" title="Add Attachment"><i className="fal fa-paperclip hold-show"></i></button>
                        {sendActive ?
                            <button onClick={handleSendClick} className="btn btn-input-action hold-show" title="Send"><i className="fal fa-paper-plane hold-show"></i></button>
                            :
                            <button onClick={() => { }} className="btn btn-input-action hold-show" title="Send" disabled><i className="fal fa-paper-plane hold-show"></i></button>
                        }
                    </div>
                </>
                    : null
                }
                {(!editable && allData.comment) && <ShowMoreHide show={allData.comment ? allData.comment : ""} attachInfo={(allData.attachments && allData.attachments.length) ? <FeedAttachments attachments={allData.attachments} isEditable={editableArr.includes(allData.id)} allData={allData} deletedFile={deletedFileHandle} /> : null} />}
            </div>
            {editable && (allData.attachments && allData.attachments.length) ?
                <div className="attach-comments">
                    <FeedAttachments attachments={allData.attachments} isEditable={editableArr.includes(allData.id)} allData={allData} deletedFile={deletedFileHandle} setDeletedFileData={setDeletedFileData}/>
                </div>
                : null}

            {inputError != '' ? <div className="invalid-feedback d-block">{inputError}</div> : null}
            {showMore ? <div onClick={() => { setShowMore(false); setShowLess(true) }} className="show-more-txt">See more</div> : null}
            {showLess ? <div onClick={() => { setShowLess(false); setShowMore(true) }} className="show-more-txt">See less</div> : null}

            {renderVideos()}
            {editable ? <>
                <input
                    type="file"
                    ref={btnAttachment}
                    style={{ display: "none" }}
                    className='hold-show'
                    onChange={(e) => handleFiles(e)}
                />

                <div
                    className={
                        !showFilePond ? "hideFilePond" : "showFilePond"
                    }
                    onClick={(e)=>e.stopPropagation()}
                >
                    <FilePond
                        name="post"
                        allowMultiple={true}
                        maxFiles={10}
                        ref={filePondRef}
                        files={files}
                        onupdatefiles={setFiles}
                        beforeRemoveFile={(f) => { setRemoveFile(f.file.name); attachmentsArrUpdate(f.file.name) }}
                        onaddfile={(err, fileItem) => {
                            setShowFilePond(true);
                        }}
                        server={{
                            url: API_BASE,
                            process: {
                                url: "/addFeedAttachments",
                                headers: {
                                    Authorization: `Bearer ${getToken()}`,
                                },
                                onload: (response) => {
                                    handleUploadedFiles(response);
                                },
                                ondata: (formData) => {
                                    formData.append('datasize', true);
                                    return formData;
                                },
                            },
                            revert: {
                                url: `/removeFeedAttachments/${removeFile}`,
                                headers: {
                                    Authorization: `Bearer ${getToken()}`,
                                },
                                onload: (response) => {
                                    setRemoveFile(null);
                                },
                            },
                        }}
                    />
                </div>
            </>
                :
                null}

        </div>
    );
}

export default React.memo(HtmlInputEditorShowComment);
